	
  <!-- 消息提示框

  •	支持 4 种类型：success, error, warning, info
	•	支持自动关闭、手动关闭
	•	支持多个提示同时显示
	•	支持全局调用：this.$message({ type: 'success', message: '操作成功' }) -->

<template>
  <div
    class="my-message"
    :class="type"
    @mouseenter="clearTimer"
    @mouseleave="startTimer"
  >
    <span class="message-icon" :class="`icon-${type}`"></span>
    <span class="title">{{ message }}</span>
  </div>
</template>

<script>
export default {
  props: {
    type: { type: String, default: "info" },
    message: { type: String, required: true },
    duration: { type: Number, default: 3000 },
  },
  data() {
    return { timer: null };
  },
  mounted() {
    this.startTimer();
  },
  methods: {
    startTimer() {
      if (this.duration > 0) {
        this.timer = setTimeout(this.close, this.duration);
      }
    },
    clearTimer() {
      clearTimeout(this.timer);
    },
    close() {
      this.$emit("close");
    },
  },
};
</script>

<style scoped lang="scss">
@function toRem($x) {
  @return $x / 37.5 * 1rem;
}

@keyframes message-in {
  from {
    opacity: 0;
    transform: translateX(-50%) translateY(toRem(-8));
  }
  to {
    opacity: 1;
    transform: translateX(-50%) translateY(0);
  }
}

.my-message {
  position: fixed;
  left: 50%;
  top: toRem(40);
  transform: translateX(-50%);
  display: inline-flex;
  align-items: center;
  gap: toRem(10);
  min-width: toRem(280);
  max-width: calc(100vw - #{toRem(40)});
  padding: toRem(14) toRem(16);
  border-radius: toRem(12);
  background: linear-gradient(180deg, #e8f4fc 0%, #ffffff 50%);
  box-sizing: border-box;
  pointer-events: all;
  z-index: 9999;
  animation: message-in 0.25s ease-out;
  border: 1px solid rgba(0, 163, 209, 0.12);
  box-shadow: 0 toRem(8) toRem(24) rgba(0, 163, 209, 0.12);
  font-family: PingFang SC, PingFang SC, sans-serif;
}

.message-icon {
  flex-shrink: 0;
  width: toRem(27);
  height: toRem(27);
  border-radius: 50%;
  position: relative;

  &::before,
  &::after {
    content: "";
    position: absolute;
    box-sizing: border-box;
  }
}

.title {
  flex: 1;
  font-weight: 400;
  font-size: toRem(14);
  line-height: toRem(22);
  color: #333333;
  word-break: break-word;
  text-align: left;
}

/* success / info：品牌色 #00a3d1 */
.my-message.success .message-icon,
.my-message.info .message-icon {
  background: #00a3d1;
}

.my-message.success .message-icon::before,
.my-message.info .message-icon::before {
  left: toRem(8);
  top: toRem(6);
  width: toRem(6);
  height: toRem(11);
  border-right: toRem(2) solid #ffffff;
  border-bottom: toRem(2) solid #ffffff;
  transform: rotate(45deg);
}

.my-message.info .message-icon::before {
  left: 50%;
  top: toRem(5);
  width: toRem(2);
  height: toRem(2);
  margin-left: toRem(-1);
  background: #ffffff;
  border: none;
  border-radius: 50%;
  transform: none;
}

.my-message.info .message-icon::after {
  left: 50%;
  top: toRem(9);
  width: toRem(2);
  height: toRem(10);
  margin-left: toRem(-1);
  background: #ffffff;
  border-radius: 1px;
}

/* warning */
.my-message.warning .message-icon {
  background: #e6a23c;
}

.my-message.warning .message-icon::before {
  left: 50%;
  top: toRem(5);
  width: toRem(2);
  height: toRem(10);
  margin-left: toRem(-1);
  background: #ffffff;
  border-radius: 1px;
}

.my-message.warning .message-icon::after {
  left: 50%;
  bottom: toRem(5);
  width: toRem(2);
  height: toRem(2);
  margin-left: toRem(-1);
  background: #ffffff;
  border-radius: 50%;
}

/* error */
.my-message.error .message-icon {
  background: #f56c6c;
}

.my-message.error .message-icon::before,
.my-message.error .message-icon::after {
  left: 50%;
  top: 50%;
  width: toRem(12);
  height: toRem(2);
  margin-left: toRem(-6);
  margin-top: toRem(-1);
  background: #ffffff;
  border-radius: 1px;
}

.my-message.error .message-icon::before {
  transform: rotate(45deg);
}

.my-message.error .message-icon::after {
  transform: rotate(-45deg);
}
</style>



// WEBPACK FOOTER //
// message.vue?6f843455